import React from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "../../../../../utils/notifications";
import LoaiPhieuThuChiApi from "service/QuanTriHeThong/LoaiPhieuThuChi/LoaiPhieuThuChiApi";

export const ModalMoKhoa = ({ show, onHide, item, onChanged, type }) => {
    const [isSubmit, setIsSubmit] = React.useState(false);
    if (!item) return null;

    const isKhoa = type !== "mokhoa";

    const onSubmit = async () => {
        setIsSubmit(true);
        try {
            const response = await LoaiPhieuThuChiApi.changeStatus(item.LoaiThuChiId);
            if (response.status === 200) {
                pushNotification(isKhoa ? "Khóa thành công!" : "Mở khóa thành công!", "success", "TOP_CENTER", 2000);
                if (onChanged) onChanged();
            } else {
                pushNotification(isKhoa ? "Khóa thất bại!" : "Mở khóa thất bại!", "error", "TOP_CENTER", 2000);
            }
        } catch {
            pushNotification(isKhoa ? "Khóa thất bại!" : "Mở khóa thất bại!", "error", "TOP_CENTER", 2000);
        }
        setIsSubmit(false);
        onHide();
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="modal-dialog"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left"
        >
            <Modal.Header>
                <h4 className="modal-title color7-bold" id="myModalLabel16">
                    <span className="btn-icon-right">
                        <i className={`mdi ${isKhoa ? "mdi-lock" : "mdi-lock-open-variant"}`}></i>
                    </span>
                    {isKhoa ? "Xác nhận khóa" : "Xác nhận mở khóa"}
                </h4>
                <button
                    type="button"
                    className="close-popup-new"
                    onClick={onHide}
                >
                    <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className="form form-horizontal">
                    <div className="form-body">
                        <div className="form-body text-center">
                            <p style={{ fontSize: '16px' }}>{isKhoa ? "Bạn có chắc chắn muốn khóa loại phiếu này?" : "Bạn có chắc chắn muốn mở khóa loại phiếu này?"}</p>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-new-main btn-closenew"
                    onClick={onHide}
                >
                    <span>
                        <i className="mdi mdi-close"></i>
                    </span>
                    &nbsp; Hủy
                </button>

                <button
                    type="button"
                    className="btn btn-new-main button-popup-submit"
                    onClick={onSubmit}
                    disabled={isSubmit}
                >
                    <span>
                        <i className={`mdi ${isKhoa ? "mdi-lock" : "mdi-lock-open-variant"}`}></i>
                    </span>
                    &nbsp; Đồng ý
                </button>
            </Modal.Footer>
        </Modal>
    );
};